<div class="row m-3">
    <div class="col-md-12 p-2 mat-elevation-z8 productos bg-white tabla-productos scrollbar-info">
        <mat-grid-list class="py-3" cols="1" rowHeight="40px">
            <mat-grid-tile *ngFor="let material of materiales">
                <div class="w-100 text-center">
                    <a mat-raised-button color="primary" class="m-1 col-md-7 col-9"
                        (click)="openCalculadora(material._id)">{{material.name}}</a>
                    <i class="fas fa-trash-alt ml-1" (click)="deleteMaterial(material._id)"></i>
                    <i class="fas fa-edit ml-1" (click)="editMaterial(material._id)" data-toggle="modal"
                        data-target="#modalEditarMaterial"></i>
                </div>
            </mat-grid-tile>
        </mat-grid-list>

    </div>
    <div class="p-0 w-100 mt-3">
        <button mat-raised-button color="accent" class="w-100" (click)="addMaterial()">Agregar material</button>
    </div>
</div>